var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 28,
    r: 27.5,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05 69.156 62.574 53.674a34.2 34.2 0 0 0-6.738-45.417 34.154 34.154 0 0 0-45.834 2.26 34.196 34.196 0 0 0-2.243 45.86 34.15 34.15 0 0 0 45.395 6.726l15.473 15.479a6.744 6.744 0 0 0 9.421 0 6.67 6.67 0 0 0 0-9.426ZM34.195 10.54c4.777 0 9.446 1.417 13.418 4.072a24.178 24.178 0 0 1 3.66 37.18 24.15 24.15 0 0 1-26.32 5.239 24.15 24.15 0 0 1-10.84-8.9 24.17 24.17 0 0 1-4.07-13.426 24.2 24.2 0 0 1 7.082-17.08 24.17 24.17 0 0 1 17.07-7.085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h80v80H0z"
  })))));
};
export default SvgSearch;